<template>
    <div class="smileysMail__wrapper">
        <div class="smileysMail__top">
            <div class="smileysMail__top-icon">
                <img src="@/assets/icons/ic_qr_smileys_mail.svg">
            </div>
            <div class="smileysMail__top-title">
                {{translate('smileysMailTitle')}}
            </div>
            <div class="smileysMail__top-subtitle">
                {{translate('smileysMailSubtitle', [this.userInfo.email])}}
                <a @click="downloadSticker" class="smileysMail__link">{{translate('smileysMailDownload')}}</a>
            </div>
        </div>
        <div class="smileysMail__checklist">
            <div class="smileysMail__checklist-image">
                <img src="@/assets/images/QR_smileys_pic.png">
            </div>
            <div class="checklist-title">
                {{translate('smileysMailChecklist')}}
            </div>
            <div class="checklist-content">
                <div class="checklist-content__wrapper">
                    <div class="checklist-content__icon">
                        <img src="@/assets/icons/ic_success.svg">
                    </div>
                    <div class="checklist-content__text">
                        {{translate('smileysMailChecklistFirst')}}
                    </div>
                </div>
                <div class="checklist-content__wrapper">
                    <div class="checklist-content__icon">
                        <img src="@/assets/icons/ic_success.svg">
                    </div>
                    <div class="checklist-content__text">
                        {{translate('smileysMailChecklistSecond')}}
                    </div>
                </div>
                <div class="checklist-content__wrapper">
                    <div class="checklist-content__icon">
                        <img src="@/assets/icons/ic_success.svg">
                    </div>
                    <div class="checklist-content__text">
                        {{translate('smileysMailChecklistThird')}}
                    </div>
                </div>
                <div class="checklist-content__wrapper">
                    <div class="checklist-content__icon">
                        <img src="@/assets/icons/ic_success.svg">
                    </div>
                    <div class="checklist-content__text">
                        {{translate('smileysMailChecklistFourth')}}
                    </div>
                </div>
                <div class="checklist-content__wrapper">
                    <div class="checklist-content__more">
                        {{translate('smileysMailChecklistMore')}}
                    </div>
                </div>
            </div>
            <div class="smileysMail__btn">
                <div class="smileysMail__btn-first" @click="onDashboard">
                    {{translate('smileysMailChecklistBtn')}}
                </div>
                <a href="https://air-vote.com/" class="smileysMail__btn-second">
                    {{translate('smileysMailChecklistBack')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import config from '@/api/config';
    import errorMixin from "@/mixins/errorMixin";
    export default {
        mixins: [errorMixin],
        name: "QR_SmileysMail",

        data() {
            return {

            }
        },
        computed: {
            ...mapState ({
                userInfo: state => state.auth.userInfo,
            }),
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        methods: {
            onDashboard() {
                this.$router.push({name: 'OwnerPlaceManagement'})
            },
            downloadSticker() {
                let routeData = this.$router.resolve({name: 'loadPdf', params: {pdfUid: this.settings.pdf_uid}});
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style scoped>
    .smileysMail__wrapper {
        width: 816px;
        background: #FFFFFF;
        box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.106042);
        border-radius: 6px;
    }
    .smileysMail__top {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 37px;
    }
    .smileysMail__top-icon {
        padding-bottom: 16px;
    }
    .smileysMail__top-title {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #2F2F2F;
        padding-bottom: 15px;
        text-align: center;
    }
    .smileysMail__link {
        font-family: Nunito;
        font-style: normal;
        cursor: pointer;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #448aff !important;
    }
    .smileysMail__top-subtitle {
        width: 544px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        padding-bottom: 25px;
    }
    .smileysMail__checklist {
        height: 360px;
        background-color: rgba(243, 243, 243, 0.4);
        padding-top: 32px;
        padding-left: 64px;
        position: relative;
    }
    .smileysMail__checklist-image {
        position: absolute;
        right: 0;
        top: 20px;
    }
    .checklist-content {
        padding-top: 16px;
    }
    .checklist-title {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
    }
    .checklist-content__wrapper {
        display: flex;
        align-items: center;
        padding-bottom: 8px;
    }
    .checklist-content__text {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        padding-left: 10px;
    }
    .checklist-content__more {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        padding-top: 8px;
    }
    .smileysMail__btn {
        display: flex;
        padding-top: 48px;
        align-items: center;
    }
    .smileysMail__btn-first {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        padding: 12px 14px;
        background-color: #3F405C;
        cursor: pointer;
        border-radius: 6px;
        margin-right: 33px;
        text-align: center;
    }
    .smileysMail__btn-second {
        color: #3F405C;
        cursor: pointer;
    }

    @media screen and (max-width: 820px) {
        .smileysMail__wrapper {
            width: auto;
        }
        .smileysMail__checklist-image {
            display: none;
        }
        .smileysMail__top-subtitle {
            padding-left: 15px;
            padding-right: 15px;
            
        }

    }

    @media screen and (max-width: 565px) {
        .smileysMail__top-subtitle {
            width: auto;
        }
        .smileysMail__btn {
            flex-direction: column;
        }
        .smileysMail__checklist {
            height: auto;
        }
        .smileysMail__btn-second {
            padding-top: 25px;
            padding-bottom: 25px;
        }
        .smileysMail__checklist {
            padding-left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 15px;
            padding-right: 15px;
        }
        .smileysMail__top {
            padding-left: 15px;
            padding-right: 15px;
        }
        .smileysMail__btn-first {
            margin-right: 0;
        }
    }
    @media screen and (max-width: 376px) {
        .checklist-content__icon img {
            height: 24px !important;
            width: 24px !important;
            max-width: initial;
        }
    }
</style>